import { createContext } from "react";

export interface EmployeeTrigger {
    type: "employee";
    employeeId: string;
}

export interface RoomTrigger {
    type: "room";
    roomId: string;
}

export interface EmptySeatTrigger {
    type: "empty-seat";
    seatId: string;
}

export interface PathTrigger {
    type: "path";
    path: string[] | null;
}

export interface NavPointTrigger {
    type: "nav-point";
    pointId: string;
}

export interface NavEdgeTrigger {
    type: "nav-edge";
    id1: string;
    id2: string;
}

export interface NavConnectTrigger {
    type: "nav-connect";
    startPointId: string;
}

export interface UtilityTrigger {
    type: "utility";
    utilityId: string;
}

export type Trigger =
    | EmployeeTrigger
    | RoomTrigger
    | EmptySeatTrigger
    | PathTrigger
    | NavPointTrigger
    | NavConnectTrigger
    | NavEdgeTrigger
    | UtilityTrigger;
type InfoPopoverState = {
    trigger: Trigger | null;
    setTrigger: (trigger: Trigger | null) => void;
};

const InfoPopoverContext = createContext<InfoPopoverState>({
    trigger: null,
    setTrigger: () => {},
});

export { InfoPopoverContext };
